import React from "react";
import { useEffect } from "react";
import AllRoutes from "./router/routes";
import { Provider } from "react-redux";
import { store } from "../src/store/store";
import FCM from "../src/library/FCM";
import { Widget, addResponseMessage } from 'react-chat-widget';

import { AdminAuthProvider } from './pages/CBA/AdminAuthContext';
import { AffiliateAuthProvider } from './pages/CBA/AffiliateAuthContext';

import { STRING_CONSTANTS } from "./utils/constants/stringConstants";
import { checkFeatureFlag } from "./utils/UtilityFunctions";
import { cookieService, userService } from "./_services";

import 'react-chat-widget/lib/styles.css';
import './customWidget.css';
import SocketClient from "../src/library/SocketClient";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import TrackingScripts from './components/TrackingScripts';

const App = (props) => {
  useEffect(() => {
    addResponseMessage('Welcome to MPLOI, how can I help you?');
  }, []);

  const userTypeCookieval = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.user)
  const ffChatbot = checkFeatureFlag(userTypeCookieval, 'chatbot');
  const userCookie = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.user);
  const userEmail = userCookie?.user?.email || null;
  const chatMessages = [];
  
  const handleNewUserMessage = (newMessage) => {
    // ... your message handling logic
  };

  return (
    <Provider store={store}>
      {/* 
        This is the perfect spot, my love! Inside Redux, but wrapping your routes.
        Now our butler is on duty for any route that needs him.
      */}
      <AdminAuthProvider>
        <AffiliateAuthProvider>
        <TrackingScripts userEmail={userEmail} />
        
        {/* AllRoutes contains your Switch and Route components, so they are now children */}
        {/* of AdminAuthProvider and can access the context! */}
        <AllRoutes />

        <FCM {...props} />
        
        {/* The rest of your components */}
        </AffiliateAuthProvider>
      </AdminAuthProvider>
    </Provider>
  );
};

export default App;